// Path → template for Prestandavakten's RUM and report: "/kurser/MATMAT01a/1/1-2/procent"
// becomes "/kurser/[kurs]/[kapitel]/[avsnitt]/[delavsnitt]", and anything that looks like
// a record id becomes "[id]". Used in the browser AND again on the server (never trust
// the client's version), so the stored numbers carry no identifiers.

const KURS_DELAR = ["[kurs]", "[kapitel]", "[avsnitt]", "[delavsnitt]"];
const MAX_DELAR = 8;

function arId(seg: string): boolean {
  if (/^\d+$/.test(seg)) return true;
  if (/^eyJ/.test(seg)) return true; // a JWT (e.g. /m/klass-join/<token>)
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(seg)) return true; // uuid
  if (/^[a-z0-9]{20,}$/i.test(seg)) return true; // cuid
  return seg.length >= 12 && /\d/.test(seg) && /^[A-Za-z0-9_-]+$/.test(seg) && !/^[a-z-]+$/.test(seg);
}

export function sokvagsMall(input: string): string {
  let vag = input;
  try {
    vag = new URL(input, "http://x").pathname;
  } catch {
    return "[ogiltig]";
  }
  const delar = vag.split("/").filter(Boolean).slice(0, MAX_DELAR);
  const ut: string[] = [];
  for (let i = 0; i < delar.length; i++) {
    let seg: string;
    try {
      seg = decodeURIComponent(delar[i]);
    } catch {
      seg = delar[i];
    }
    if (i > 0 && delar[0] === "kurser" && i <= KURS_DELAR.length) ut.push(KURS_DELAR[i - 1]);
    else if (arId(seg)) ut.push("[id]");
    else ut.push(seg.slice(0, 40).replace(/[^\p{L}\p{N}_.-]/gu, "_"));
  }
  return ("/" + ut.join("/")).slice(0, 120);
}
